import { request } from "../helper/axios_helper";

// ─── On-prem automation agents (Admin → Agents) ───────────────
// Backend: AgentAdminController on the user (JWT) security chain.

// Create an agent → returns { agentId, key, environment }. The raw `key` is
// shown ONCE here and never again (only its SHA-256 hash is stored).
export const createAgent = (name, environment) =>
  request("POST", "/api/auth/admin/agents/create", { name, environment });

// List agents (hashedKey is nulled out by the backend).
export const listAgents = () =>
  request("GET", "/api/auth/admin/agents/list");

// Revoke an agent — its key stops authenticating immediately.
export const revokeAgent = (agentId) =>
  request("POST", `/api/auth/admin/agents/${agentId}/revoke`);
